module.exports = __webpack_public_path__ + "img/02_03.1835cefe.png";